import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import absoluteURL from "@/lib/absoluteURL";

export function tags(channel, link, course) {
  const viewType = link?.values?.view_type;
  const url = link?.url;
  const genre = channel?.genres?.[0]?.name || "";
  const trialText = course?.trial_flag
    ? ` | ${course?.trialTerm}トライアル実施中`
    : "";
  switch (viewType) {
    case "live_schedule":
      return {
        title: `${channel.name}【${genre}】 - ${link.title} の動画配信 | スカパー！動画ストア`,
        keywords: `${channel.name},スカパー！動画ストア,動画配信,番組表,スカパー！`,
        description: `${link.title}。スカパー！動画ストアでは、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id, url)}`,
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
        twitter: {
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
      };

    case "palette":
      return {
        title: `${channel.name}【${genre}】 - ${link.title} の動画配信 | スカパー！動画ストア`,
        keywords: `${channel.name},スカパー！動画ストア,動画配信,スカパー！`,
        description: `${link.title}。スカパー！動画ストアでは、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id, url)}`,
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
        twitter: {
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
      };

    case "canvas":
    default:
      return {
        title: `${channel.name}【${genre}】の動画配信 | スカパー！動画ストア`,
        keywords: `${channel.name},スカパー！動画ストア,動画配信,スカパー！`,
        description: `スカパー！動画ストアでは、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id)}`,
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
        twitter: {
          title: `スカパー！動画ストア ${channel?.name} 月額${course?.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({ url: channel?.thumbnailUrl }),
        },
      };
  }
}

export default function ChannelDetailMetaTags({ channel, link, course }) {
  const props = tags(channel, link, course);

  return <MetaTags {...props} />;
}
